<template>
  <div>
    <v-card>
      <v-card-title style="text-decoration:underline ">
        {{ $t("STUDENTS_DESIRES_ALLOCATION") }}
      </v-card-title>

      <v-form ref="filterForm">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-alert
                  border="left"
                  class="pa-3"
                  colored-border
                  elevation="2"
                  type="info"
              >
                <strong style="color: #2196f3 !important">{{ $t("DESIRES_ALLOCATION_RUN_NOTE") }}</strong>
                <ol class="mt-2 pr-4">
                  <li
                      v-for="(item, index) in $t('DESIRES_ALLOCATION_RUN_NOTE_TEXT')"
                      :key="index"
                  >
                    <strong>{{ item }}</strong>
                  </li>
                </ol>
              </v-alert>
            </v-col>

            <v-col cols="12" lg="6" md="6" sm="6" xs="6">
              <v-btn ref="applyBtn"
                     color="primary" dark v-bind="attrs" @click="runApprovalRule"
                     v-on="on">
                {{ $t("APPLY_ACCEPTANCE_RULE") }}
              </v-btn>
            </v-col>


            <v-row v-if="acceptedStu && acceptedStu.length > 0">
  <!-- Faculty -->
  <v-col cols="12" lg="4" md="4" sm="12">
    <v-select
        v-model="facultyId"
        :items="[
          {
            facultyId: null,
            facultyName: 'كل الكليات'
          },
          ...serverTranslateArray(faculties, 'facultyName')
        ]"
        :label="$t('FACULTY')"
        clearable
        item-text="facultyName"
        item-value="facultyId"
        outlined
    ></v-select>
  </v-col>

  <!-- Certificate -->
  <v-col cols="12" lg="4" md="4" sm="12">
    <v-select
        v-model="certificateType"
        :items="certificateTypes"
        :label="$t('CERTIFICATE')"
        clearable
        item-text="name"
        item-value="id"
        outlined
    ></v-select>
  </v-col>

  <!-- Specialization / Division -->
  <v-col cols="12" lg="4" md="4" sm="12">
    <v-select
        v-model="divisionType"
        :items="divisionTypes"
        :label="$t('ADMISSION_DATA.STEP2.MAJOR')"
        clearable
        item-text="name"
        item-value="id"
        outlined
    ></v-select>
  </v-col>

            </v-row>


            <!--            <v-col cols="6" lg="6" md="6" sm="6" xs="6">-->
            <!--              <v-select-->
            <!--                  v-if=" filteredStudents && filteredStudents.length > 0 "-->
            <!--                  v-model="facultyId"-->
            <!--                  :items="[{facultyId: null, facultyName: 'كل الكليات'}, ...serverTranslateArray(faculties, 'facultyName')]"-->
            <!--                  :label="$t('FACULTY')"-->
            <!--                  class="col-9 d-inline-flex"-->
            <!--                  item-text="facultyName"-->
            <!--                  item-value="facultyId"-->
            <!--                  outlined-->
            <!--              ></v-select>-->
            <!--            </v-col>-->

          </v-row>
        </v-container>
      </v-form>

      <pr-confirmDialog ref="confirm"></pr-confirmDialog>
    </v-card>
    <v-card class="mt-5">
      <v-tabs
          v-model="tab"
          centered
          icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab class="secondary--text"
               href="#tab-1"
        >
          {{ $t("ACCEPT_CANDIDATES") }}
          <v-icon>mdi-account-check</v-icon>
        </v-tab>
      </v-tabs>
      <div class="d-flex justify-right  my-2 mx-2">
        <v-btn v-if="filteredStudents && filteredStudents.length > 0"
               :disabled="acceptingApplications" :loading="acceptingApplications"
               class="white--text"
               color="primary"
               @click="acceptApplications(filteredStudents)">
          {{ $t("ACCEPT_APPLICATIONS") }}
        </v-btn>
      </div>
      <v-tabs-items v-model="tab">
        <v-tab-item
            value="tab-1"
        >
          <v-card flat>
            <v-card-content>
              <v-data-table
                  :footer-props="{
                       showFirstLastPage: true,
                       firstIcon: 'mdi-arrow-collapse-left',
                       lastIcon: 'mdi-arrow-collapse-right',
                       prevIcon: 'mdi-arrow-left',
                       nextIcon: 'mdi-arrow-right',
                       itemsPerPageOptions: [10, 20, 30, 40,50,100]
                       }"
                  :headers="headers"
                  :hide-default-footer="filteredStudents.length > 0 ? false : true"
                  :items="serverTranslateArrayKeys(filteredStudents, ['studentName', 'facultyName', 'branch','qualTypeName','qualDivisionName'])"
                  :items-per-page="10"
                  :loading="loading"
                  class="elevation-1 pointer"
                  @click:row="openApplicationDetails"
              />
              <template v-slot:footer.page-text="props">
                {{ props.pageStart }} - {{ props.pageStop }} {{ $t('PAGE_TEXT') }} {{ props.itemsLength }}
              </template>
            </v-card-content>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <ShowApplicationDetails/>
    </v-card>
  </div>
</template>
<script>
import globalMethodsMixin from "@/mixins/globalMethods.ts";
import serverTranslationsMixin from "@/mixins/serverTranslations.ts";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import ShowApplicationDetails from "@/components/modules/studentData/ManageApplications/ShowApplicationDetails";
import {EventBus} from "@/plugins/bus";

export default {
  mixins: [serverTranslationsMixin, globalMethodsMixin],
  components: {
    "pr-confirmDialog": ConfirmDialog,
    ShowApplicationDetails
  },
  mounted() {
    this.$store.state.Auth.facultyID = null;
    this.getFacultiesWithRules()
    this.acceptedStu = []
    this.rejectedStu = []
  },
  data() {
    return {
      acceptingApplications: false,
      grouped: [],
      faculties: [],
      availableCert: [],
      CertificateBasicTypes: [],
      priorityId: "",
      facultyId: "",

     // Algorithm result filters
    certificateType: null,
    divisionType: null,

      studentNumber: 0,
      totalDegree: 0,
      ruleId: false,
      tab: "tab-1",
      loading: false,
      total: 0,
      options1: {},
      options2: {},
      statusStudent: 1,
      acceptedStu: [],
      acceptedStuWithoutLimit: [],
      rejectedStuWithoutLimit: [],
      rejectedStu: [],
      totalPagesAccept: 0,
      totalPagesReject: 0,
      selectedDesire: ""
    }
  },
  methods: {
    getFacultiesWithRules() {
      const rules = {
        "hasRules": true
      }
      this.$http.post("/api/general_data/list_faculties_with_rules/", rules)
          .then(
              res => {
                this.faculties = res.data.data.faculties;
                this.CertificateBasicTypes = res.data.data.CertificateBasicTypes;
                this.availableCert = res.data.data.CertificateBasicTypes;
                this.grouped = this.faculties.reduce((acc, item) => {
                  if (!acc[item.facultyId]) {
                    acc[item.facultyId] = {
                      facultyId: item.facultyId,
                      certificateIds: []
                    };
                  }
                  acc[item.facultyId].certificateIds.push(item.certificateId);
                  return acc;
                }, {});
              },
              err => {
                this.showToasted("error", err.response.data.message)
              })
    },
    resetSearchView() {
      this.tab = "tab-1";
    },
    acceptApplications(acceptedStuWithoutLimit) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "ACCEPT_ALL_APPLICATION_CONFIRM")
          .then(confirm => {
            if (confirm) {
              const data = {
                appStudentData: acceptedStuWithoutLimit,
                statusStudentUpdated: "2"
              };

              this.acceptingApplications = true;

              this.$http
                  .put("/api/approval_rules/edit_status_all_recommended/", data)
                  .then(res => {
                    this.showToasted("success", res.data.message);
                    this.getAccepted();
                  })
                  .catch(err => {
                   this.showToasted("success");
                  })
                  .finally(() => {
                    this.acceptingApplications = false;
                  });
            }
          });
    }
    ,

    runApprovalRule() {
      this.$refs.applyBtn.$el.style.display = 'none';
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "APPLY_RULE_CONFIRM")
          .then(confirm => {
            if (confirm) {
              this.loading = true
              this.$http.post("/api/tansiq/run_tansiq/")
                  .then(
                      res => {
                        this.loading = true
                        this.showToasted("success", res.data.message)
                        this.acceptedStu = res.data.data.allData;
                        this.total = res.data.data.allData.length;
                        this.loading = false
                      },
                      err => {
                        this.loading = true
                        this.showToasted("error", err.response.data.message)
                      }
                  )
            }
          })
      this.$refs.applyBtn.$el.style.display = 'block';
    },
    openApplicationDetails($event) {
      const applicationId = $event.applicationNumber;
      const studentId = $event.studentId;
      EventBus.$emit('showApplicationDetails', applicationId, studentId, false)
    },
  },
  computed: {
    filteredStudents() {
  return this.acceptedStu.filter(student => {

    // Faculty
    if (
      this.facultyId !== null &&
      this.facultyId !== "" &&
      parseInt(student.resultFacultyID) !== parseInt(this.facultyId)
    ) {
      return false;
    }

    // Certificate
    if (
      this.certificateType !== null &&
      this.certificateType !== "" &&
      String(student.qualTypeID) !== String(this.certificateType)
    ) {
      return false;
    }

    // Specialization
    if (
      this.divisionType !== null &&
      this.divisionType !== "" &&
      String(student.qualDivisionID) !== String(this.divisionType)
    ) {
      return false;
    }

    return true;
  });
},
    divisionTypes() {
  const result = [
    {
      id: null,
      name: "كل التخصصات"
    }
  ];

  const seen = {};

  this.acceptedStu
    .filter(student => {
      if (
        this.certificateType !== null &&
        this.certificateType !== "" &&
        String(student.qualTypeID) !== String(this.certificateType)
      ) {
        return false;
      }

      return true;
    })
    .forEach(student => {
      const id = student.qualDivisionID;

      if (
        id !== null &&
        id !== undefined &&
        id !== "" &&
        !seen[String(id)]
      ) {
        seen[String(id)] = true;

        result.push({
          id: id,
          name: this.serverTranslate(student.qualDivisionName)
        });
      }
    });

  return result;
},
    certificateTypes() {
  const result = [
    {
      id: null,
      name: "كل الشهادات"
    }
  ];

  const seen = {};

  this.acceptedStu.forEach(student => {
    const id = student.qualTypeID;

    if (
      id !== null &&
      id !== undefined &&
      id !== "" &&
      !seen[String(id)]
    ) {
      seen[String(id)] = true;

      result.push({
        id: id,
        name: this.serverTranslate(student.qualTypeName)
      });
    }
  });

  return result;
},
    direction: function () {
      return this.$store.state.direction;
    },
    headers: function () {
      return [
        {
          text: this.$t("STUDENT_NAME"),
          align: "start",
          value: "studentName",
          sortable: false,
        },
        {
          text: this.$t("FACULTY_NAME"),
          value: "facultyName",
          sortable: false
        },
        {
          text: this.$t("APPID"),
          value: "applicationNumber",
          sortable: false
        }
        , {
          text: this.$t("UserData.DESIRE_NUMBER"),
          value: "desireNumber",
          sortable: false
        },
        {
          text: this.$t("CERTIFICATE_TYPE"),
          value: "qualTypeName",
          sortable: false
        },
        {
          text: this.$t("ADMISSION_DATA.STEP2.MAJOR"),
          value: "qualDivisionName",
          sortable: false
        },

        {
          text: this.$t("TOTAL_DEGREE"),
          value: "totalDegree",
          sortable: true
        }, {
          text: this.$t("CERTIFIED_DEGREE"),
          value: "submittedTotal",
          sortable: true
        },
        {
          text: this.$t("APPLY_DATE"),
          value: "applyDate",
          sortable: true
        },
        {
          text: this.$t("STUDENT_NID"),
          value: "studentIdentity",
          sortable: false,
        },
        {
          text: this.$t("BRANCH"),
          value: "branch",
          sortable: false
        },
      ];
    }
  },
};
</script>
